meedy.factory('meedy.rightModel', ['$rootScope', 'meedy.baseModel', 'meedy.rightService',
    function($rootScope, baseModel, rightService) {

        function RightModel() {

            this.getListByUserType = function(userType) {
                rightService.getListByUserType(userType).then(
                    function (list) {
                        $rootScope.$broadcast(Event.MEEDY.RIGHT.GET_LIST_BY_USER_TYPE.SUCCESS, list);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.RIGHT.GET_LIST_BY_USER_TYPE.ERROR, error);
                    }
                )
            };

        }

        return new RightModel();
    }
]);
